import { render, staticRenderFns } from "./OsResetPasswordForm.vue?vue&type=template&id=1c7a3066&scoped=true"
import script from "./OsResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./OsResetPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a3066",
  null
  
)

export default component.exports